<template>
    <section class="fivePower">
        <div class="container">
            <div class="fivePower__content row">
                <h2 class="fivePower__title for-mobile">五力評選指標</h2>
                <div class="fivePower__img">
                    <img src="@/assets/images/fivepower__img.svg" alt="五力評選指標" class="rwdimgmax" />
                    <div class="fivePower__img__icons">
                        <div
                            class="fivePower__img__icon publicity"
                            :class="{'active': activeIndex === 0}"
                            @click="handleSlideTo(0)">
                        </div>
                        <div
                            class="fivePower__img__icon share"
                            :class="{'active': activeIndex === 1}"
                            @click="handleSlideTo(1)">
                        </div>
                        <div
                            class="fivePower__img__icon search"
                            :class="{'active': activeIndex === 2}"
                            @click="handleSlideTo(2)">
                        </div>
                        <div
                            class="fivePower__img__icon engagement"
                            :class="{'active': activeIndex === 3}"
                            @click="handleSlideTo(3)">
                        </div>
                        <div
                            class="fivePower__img__icon drive"
                            :class="{'active': activeIndex === 4}"
                            @click="handleSlideTo(4)">
                        </div>
                    </div>
                </div>
                <div class="fivePower__detail">
                    <h2 class="fivePower__title for-pc">五力評選指標</h2>
                    <swiper
                        :modules="swiperModules"
                        :effect="'fade'"
                        :fadeEffect="{
                            crossFade: true
                        }"
                        :autoplay="{
                            delay: 2500,
                            disableOnInteraction: false,
                        }"
                        navigation
                        @slideChange="onSlideChange($event)"
                        @swiper="onSwiper($event)"
                    >
                        <swiper-slide v-for="fivePower in fivePowerList" :key="fivePower.title">
                            <h3>{{ fivePower.title }}</h3>
                            <p>{{ fivePower.content }}</p>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref } from 'vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, EffectFade, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';


import fivePowerList from '@/assets/data/fivePower.json';

const swiperModules = [ Autoplay, EffectFade, Navigation];

const activeIndex = ref(0);

const onSlideChange = evt => {
    activeIndex.value = evt.activeIndex;
}

const toSwiper = ref(null);
const onSwiper = evt => {
    toSwiper.value = evt;
}

const handleSlideTo = idx => toSwiper.value.slideTo(idx);
</script>

<style lang="scss" scoped>
@import '@/styles/fivePower';
</style>
